<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.records" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>
    </div>
    <br />
    <n-items>
      <n-input title="Номер захватки / Номер котлована" v-bind="$form.input('number')" :text="!edit.records" />
      <n-input title="Вытрамбовывание котлована: Количество ударов" v-bind="$form.input('rammingPitPunchCount')" :text="!edit.records" />
      <n-input title="Вытрамбовывание котлована: Глубина котлована, м" v-bind="$form.input('rammingPitDepth')" :text="!edit.records" />
      <n-input title="Втрамбовывание жесткого материала порциями (Первая): Объем порции, м3" v-bind="$form.input('rammingMaterial1Volume')" :text="!edit.records" />
      <n-input title="Втрамбовывание жесткого материала порциями (Первая): Количество ударов" v-bind="$form.input('rammingMaterial1Punches')" :text="!edit.records" />
      <n-input title="Втрамбовывание жесткого материала порциями (Вторая): Объем порции, м3" v-bind="$form.input('rammingMaterial2Volume')" :text="!edit.records" />
      <n-input title="Втрамбовывание жесткого материала порциями (Вторая): Количество ударов" v-bind="$form.input('rammingMaterial2Punches')" :text="!edit.records" />
      <n-input title="Втрамбовывание жесткого материала порциями (Третья): Объем порции, м3" v-bind="$form.input('rammingMaterial3Volume')" :text="!edit.records" />
      <n-input title="Втрамбовывание жесткого материала порциями (Третья): Количество ударов" v-bind="$form.input('rammingMaterial3Punches')" :text="!edit.records" />
      <n-input title="Состояние стенок котлована" v-bind="$form.input('condition')" :text="!edit.records" />
      <n-input title="Несоответствия проекту" v-bind="$form.input('problem')" :text="!edit.records" />
    </n-items>

    <br />
    <n-divide>
      <n-button v-if="edit.records" color="success" @click="save">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>
  </n-modal>
</template>

<script>
import utils from 'utils'

export default {
  name: 'ModalRecord',
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        records: this.record.status === 'formed' && $app.auth.can('journals_spec38_records', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.spec38.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      this.$var('load', true)
      $api.journals.spec36.records.accept(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
